import { StatsCard } from '@/components/modules';
import type {
  SiteComprehensiveStatus,
  SiteData,
  SiteStats,
} from '@/types/site';
import { useMemo } from 'react';

interface SiteStatsCardsProps {
  sites: SiteData[];
  comprehensiveStatusData: Record<string, SiteComprehensiveStatus>;
  stats?: SiteStats;
  isLoading?: boolean;
}

export default function SiteStatsCards({
  sites,
  isLoading = false,
  comprehensiveStatusData,
}: SiteStatsCardsProps) {
  // 동적으로 통계 계산
  const calculatedStats = useMemo(() => {
    const comprehensiveDatas = Object.values(comprehensiveStatusData);

    if (isLoading || !sites.length) {
      return {
        activeSites: 0,
        inspectionSites: 0,
        waitingSites: 0,
        averageWaterLevel: 0,
      };
    }

    const activeSites = comprehensiveDatas.filter(
      (data) => data.hasNoError
    ).length;
    const inspectionSites = comprehensiveDatas.filter(
      (data) => !data.hasNoError
    ).length;
    const averageTemperature =
      comprehensiveDatas.reduce((acc, data) => acc + data.temperature, 0) /
      comprehensiveDatas.length;
    // 평균 수위
    const averageWaterLevel =
      comprehensiveDatas.reduce(
        (acc, data) => acc + data.waterLevel.current,
        0
      ) / comprehensiveDatas.length;

    return {
      activeSites,
      inspectionSites,
      waitingSites: averageTemperature,
      averageWaterLevel: Math.round(averageWaterLevel),
    };
  }, [sites, isLoading, comprehensiveStatusData]);

  const statsData = [
    {
      value: isLoading ? '-' : calculatedStats.activeSites,
      label: '정상 현장',
      icon: 'ri-checkbox-circle-line',
      color: 'green' as const,
    },
    {
      value: isLoading ? '-' : calculatedStats.inspectionSites,
      label: '에러 현장',
      icon: 'ri-tools-line',
      color: 'red' as const,
    },
    // {
    //   value: isLoading ? '-' : calculatedStats.waitingSites.toFixed(1) + '°C',
    //   label: '평균 온도',
    //   icon: 'ri-temp-hot-line',
    //   color: 'yellow' as const,
    // },
    // {
    //   value: isLoading
    //     ? '-'
    //     : `${calculatedStats.averageWaterLevel.toFixed(1)}%`,
    //   label: '평균 수위',
    //   icon: 'ri-drop-line',
    //   color: 'cyan' as const,
    // },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mt-8">
      {statsData.map((stat, index) => (
        <StatsCard
          key={index}
          value={stat.value}
          label={stat.label}
          icon={stat.icon}
          color={stat.color}
        />
      ))}
    </div>
  );
}
